export default __webpack_public_path__ + "static/media/triber-medium2.b65326d8.jpg";